import {
  project1Laptop,
  project2Laptop,
} from "./projectImages";

export const projectData = [
  {
    id: 1,
    image: project1Laptop,
    transitionImage: project1Laptop,
    title: "Cloned of a web application to rent two-wheelers vehicle on a monthly and daily basis.",
    codeLink: "https://github.com/Arora-Shivam/ONN-BIKES-CW",
    liveLink: "https://onnbikes.netlify.app/",
    techStack: ["HTML", "CSS", "Javascript", "BootStrap"]
  },
  {
    id: 2,
    image: project2Laptop,
    transitionImage: project2Laptop,
    title: "Clone of an E-commerce fashion website Myntra used for shopping clothes.",
    codeLink: "https://github.com/Arora-Shivam/MYNTRA",
    liveLink: "https://shoponmyntra.vercel.app/",
    techStack: ["HTML","CSS","Javascript"]
  }
]
